export const PRELUDE = `
// FM oscillator with feedback & modulation control
fm=(op1, op2, index=1, feedback=.5, trig=0)->{
  // op1 = carrier frequency
  // op2 = modulator frequency
  // index = modulation depth (0–1.5 typical)
  // feedback = internal modulation feedback amount (0–1)
  // trig is passed through to sync envelope or reset phase

  // create the feedback signal from previous cycle
  fb = delay(in:sin(hz:op1,trig), time:1/op1, feedback)

  // modulator signal
  mod = sin(hz:op2,trig) * index * op1 + fb * feedback

  // final FM signal
  sin(hz:op1 + mod,trig)
}

arpodyssey=(hz,v1,v2,mix,cut,q,lfo)->{
  vco1 = saw(hz:hz * v1)
  vco2 = sqr(hz:hz * v2 + sin(hz:hz * lfo * 0.5) * 0.1)
  mix_out = vco1 * mix + vco2 * (1.0 - mix) + noise()*.05
  svflp(in:mix_out, cut, q)
}

ms20=(hz,v1,v2,mix,cut1,q1,cut2,q2,drive)->{
  vco1 = saw(hz:hz * v1)
  vco2 = sqr(hz:hz * v2)
  mix_out = vco1 * mix + vco2 * (1.0 - mix)
  hpf_out = svfhp(in:mix_out,cut:cut1,q:q1)
  lpf_out = svflp(in:hpf_out,cut:cut2,q:q2)
  tanh(in:lpf_out * drive)
}

minimoog=(hz,v1,v2,v3,mix,cut,q)->{
  osc1 = saw(hz:hz*v1)
  osc2 = saw(hz:hz*v2)
  osc3 = saw(hz:hz*v3)
  mix_out = osc1*mix + osc2*mix + osc3*mix
  mooglp(in:mix_out, cut, q)
}

pan=(in,pan=0)->{
  L = in * (1 - pan)
  R = in * (1 + pan)
  out(L, R)
}

stereo=(in,ms=10)->{
  L = in
  R = delay(in, time:ms/1000)
  out(L, R)
}

widen=(in,ms=10,cut=200)->{
  lp(in,cut) |> out(%)
  hp(in,cut) |> stereo(%,ms)
}

metronome=()->{
  pat('[1 ~ ~ ~]',(trig,v)->noise(seed:8,trig)*ar(.001,.25,trig)^10) |> out(%)
  pat('[~ 1 1 1]',(trig,v)->noise(seed:3,trig)*ar(.001,.25,trig)^14)*.75 |> out(%)
}

0
`
